import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { Password, PasswordModule } from 'primeng/password';

@Component({
  selector: 'app-custom-input-password',
  templateUrl: './custom-input-password.component.html',
  styleUrls: ['./custom-input-password.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomInputPasswordComponent),
      multi: true
    }
  ],
  imports: [CommonModule, PasswordModule, DividerModule, FormsModule, ReactiveFormsModule]
})
export class CustomInputPasswordComponent implements ControlValueAccessor {
  @ViewChild(Password) password!: Password;
  onTouched: () => void = () => { };
  onChange: (value: string) => void = () => { };

  @Input() class: string = "";
  @Input() appendTo: string = "";
  @Input() feedback: boolean = true;
  @Input() labelText: string = "";
  @Input() required: boolean = false;
  @Input() visibleDescription: boolean = true;
  @Input() value: string = "";
  @Input() disabled: boolean = false;
  @Input() inputClass: string = '';
  @Output() onChangeText = new EventEmitter<string>();
  @Output() onChangeTextOnBlur = new EventEmitter<string>();
  constructor() { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.password?.overlayVisible && this.password.alignOverlay();
    }, 100);
  }

  changeText(event: any) {
    this.value = event.target.value;
    this.onChange(this.value);
    this.onTouched();
    this.onChangeText.emit(this.value);
  }

  changeTextOnBlur(event: any) {
    this.value = (event.target.value || '').trim();
    this.onChange(this.value);
    this.onTouched();
    this.onChangeTextOnBlur.emit(this.value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  selectAllText(event: Event) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    this.value = value;
  }
}
